// @ts-nocheck

import { convertFromHourToSecond, convertFromKmToM, convertFromMToKm, convertFromSecondToHour } from '../pure/unitConversions';
import CommonApi from './../commonApi';
const convertDataToServer = regulationLimit => ({
  ...regulationLimit,
  hours: convertFromHourToSecond(regulationLimit.hours),
  hoursWeekend: convertFromHourToSecond(regulationLimit.hoursWeekend),
  distance: convertFromKmToM(regulationLimit.distance),
  distanceWeekend: convertFromKmToM(regulationLimit.distanceWeekend)
});
const convertDataFromServer = regulationLimit => {
  return {
    ...regulationLimit,
    hours: convertFromSecondToHour(regulationLimit.hours),
    hoursWeekend: convertFromSecondToHour(regulationLimit.hoursWeekend),
    distance: convertFromMToKm(regulationLimit.distance),
    distanceWeekend: convertFromMToKm(regulationLimit.distanceWeekend)
  };
};
const regulationLimit = new CommonApi('regulationLimit', 'регламент НТС', convertDataToServer, convertDataFromServer);
export default regulationLimit;
